module.exports = __webpack_public_path__ + "img/img-92.debefcf2.png";